const themeConfigModule = {
	namespaced: true,
	state: {
		themeConfig: {
			// 界面设置
			isCollapse: false,	// 菜单水平折叠效果
			isFixedHeader: false,	// 固定 Header

			// 界面显示
			isBreadcrumb: true,	// 面包屑导航Breadcrumb
			isBreadcrumbIcon: false,	// 面包屑导航Breadcrumb 图标
			isCacheTagsView: false,	// TagsView 缓存
		},
	},
	mutations: {
		// 设置布局配置
		getThemeConfig(state, data) {
			state.themeConfig = data;
		},
	},
	actions: {
		// 设置布局配置
		setThemeConfig({ commit }, data) {
			commit('getThemeConfig', data);
		},
	},
};

export default themeConfigModule;
